function Validation() {
  const errors = {};

  return errors;
}

export default Validation;
